// public/js/features/assets/api.js
export async function loadAssets() {
  const res = await window.authenticatedFetch('api/v1/assets', {});
  if (!res.ok) throw new Error('Failed to load assets');
  const data = await res.json();
  return data.assets || [];
}

export async function getAssetDetail(assetUUID) {
  const res = await window.authenticatedFetch(`api/v1/assets/${encodeURIComponent(assetUUID)}`);
  if (!res.ok) throw new Error('Asset not found');
  const data = await res.json();
  return data.asset || data;
}


export async function updateAsset(assetUUID, updates) {
  const res = await window.authenticatedFetch(`api/v1/assets/${encodeURIComponent(assetUUID)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates)
  });
  if (!res.ok) throw new Error('Update failed');
  return await res.json();
}

export async function getUnassignedDevices() {
  const res = await window.authenticatedFetch('api/v1/devices?unassigned=true');
  if (!res.ok) throw new Error('Failed to load unassigned devices');
  const data = await res.json();
  return data.devices || [];
}

export async function deleteAsset(assetUUID) {
  const res = await window.authenticatedFetch(`api/v1/assets/${encodeURIComponent(assetUUID)}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Delete failed');
  return await res.json();
}

// Edit a device slot's config (label, supervise, tether, data-only-home, thresholds).
export async function updateAssetSlot(assetUUID, slotId, patch) {
  const res = await window.authenticatedFetch(
    `api/v1/assets/${encodeURIComponent(assetUUID)}/slots/${encodeURIComponent(slotId)}`,
    { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(patch) }
  );
  if (!res.ok) throw new Error('Slot update failed');
  return await res.json();
}

// Calibrate a tethered beacon's "docked" RSSI baseline (uses live RSSI server-side).
export async function dockAssetSlot(assetUUID, slotId, rssi = undefined) {
  const res = await window.authenticatedFetch(
    `api/v1/assets/${encodeURIComponent(assetUUID)}/slots/${encodeURIComponent(slotId)}/dock`,
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(rssi != null ? { rssi } : {}) }
  );
  if (!res.ok) {
    let msg = 'Calibration failed';
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return await res.json();
}

export async function createAsset(assetData) {
  const res = await window.authenticatedFetch('api/v1/assets', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(assetData)
  });
  if (!res.ok) throw new Error(`Create failed: ${res.status}`);
  return await res.json();
}